import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import { useSLTPNumeric } from './useSLTPNumeric';
import { SvgIconType } from '../../../SvgIcon/SvgIconType';
import { ToggleButton } from '../../../ToggleButton/ToggleButton';
import { ToggleButtonType } from '../../../ToggleButton/ToggleButtonType';
import { NumericArrows } from '../../NumericComponents/NumericArrows/NumericArrows';
import { useNumericArrows } from '../../NumericComponents/NumericArrows/useNumericArrows';
import { NumericContainer } from '../../NumericComponents/NumericContainer/NumericContainer';
import { NumericInput } from '../../NumericComponents/NumericInput/NumericInput';
import { NumericPrefix } from '../../NumericComponents/NumericPrefix/NumericPrefix';
import { NumericSeparator } from '../../NumericComponents/NumericSeparator/NumericSeparator';
import { validateStep } from '../../NumericComponents/NumericValidation/numericValidation';
import { useNumericValidation } from '../../NumericComponents/NumericValidation/useNumericValidation';
export const SLTPNumeric = ({ value, variableTickList, offsetType, operationType, isSL, disabled, isTrStopButtonChecked, onValueChange, onTrStopButtonClick, validationCallback }) => {
    const { step, min, max, precision, prefix, onIncrement, onDecrement } = useSLTPNumeric({
        value,
        variableTickList,
        offsetType,
        operationType,
        isSL
    });
    const combinedValidationCallback = (params) => {
        const stepError = validateStep(params, step);
        if (stepError !== null) {
            return stepError;
        }
        if (validationCallback !== undefined) {
            return validationCallback(params);
        }
        return null;
    };
    const { validationError } = useNumericValidation({
        value,
        min,
        max,
        step,
        precision,
        validationCallback: combinedValidationCallback
    });
    const { handleIncrement, handleDecrement } = useNumericArrows({
        value,
        onIncrement,
        onDecrement,
        onValueChange
    });
    const buttonClassName = 'numeric-button';
    return (_jsxs(NumericContainer, { disabled: disabled, validationError: validationError, children: [_jsx(NumericInput, { value: value, step: step, onValueChange: onValueChange, min: min, max: max, precision: precision, onIncrement: onIncrement, onDecrement: onDecrement }), isValidString(prefix) && _jsx(NumericPrefix, { prefix: prefix }), _jsx(NumericArrows, { onIncrement: handleIncrement, onDecrement: handleDecrement }), isSL === true && (_jsxs(_Fragment, { children: [_jsx(NumericSeparator, {}), _jsx(ToggleButton, { icon: SvgIconType.TrailingStop, type: ToggleButtonType.Secondary, onClick: onTrStopButtonClick, checked: isTrStopButtonChecked, className: buttonClassName, disabled: disabled })] }))] }));
};
